import { breadcrumbSlot } from "@redotech/redo-web/breadcrumb";
import { redirect, type RouteObject } from "react-router-dom";

const supplyIntelBrandBreadcrumb = breadcrumbSlot();

/** The brand page's breadcrumb overrider matches this route's URL. */
export const SUPPLY_INTEL_ROUTE_PATH = "supply-intel";

export const warehouseManagementRoutes: RouteObject[] = [
  {
    handle: { breadcrumb: "Redo warehouse" },
    async lazy() {
      const { Page } = await import("../../app/page");
      return { element: <Page hidePadding={() => true} /> };
    },
    children: [
      {
        index: true,
        async lazy() {
          const { WarehouseManagementPage } =
            await import("../pages/warehouse-management/warehouse-management-page");

          return { Component: WarehouseManagementPage };
        },
      },
      {
        path: "refulfillment-tools",
        handle: { breadcrumb: "Refulfillment tools" },
        async lazy() {
          const { RefulfillmentToolsPage } =
            await import("../pages/refulfillment-tools/refulfillment-tools-page");

          return { Component: RefulfillmentToolsPage };
        },
      },
      {
        path: "fulfillment-group-rates",
        handle: { breadcrumb: "Fulfillment group rates" },
        async lazy() {
          const { FulfillmentGroupRatesPage } =
            await import("../pages/fulfillment-group-rates/fulfillment-group-rates-page");

          return { Component: FulfillmentGroupRatesPage };
        },
      },
      {
        path: "error-messages",
        handle: { breadcrumb: "Error messages" },
        async lazy() {
          const { ErrorMessagesPage } =
            await import("../pages/error-messages/error-messages-page");

          return { Component: ErrorMessagesPage };
        },
      },
      {
        path: "developer-tools",
        handle: { breadcrumb: "Developer tools" },
        async lazy() {
          const { DeveloperToolsPage } =
            await import("../../developer-tools/developer-tools-page");

          return { Component: DeveloperToolsPage };
        },
      },
      {
        path: SUPPLY_INTEL_ROUTE_PATH,
        handle: { breadcrumb: "Supply Intelligence" },
        children: [
          {
            index: true,
            loader: () =>
              redirect("/warehouse-management?tab=supply-intelligence"),
          },
          {
            path: ":accountId",
            handle: { breadcrumb: supplyIntelBrandBreadcrumb },
            async lazy() {
              const { SupplyIntelBrandPage } =
                await import("../pages/supply-intel-brand/supply-intel-brand-page");

              return {
                element: (
                  <SupplyIntelBrandPage
                    breadcrumb={supplyIntelBrandBreadcrumb}
                  />
                ),
              };
            },
          },
        ],
      },
      {
        path: "supplies",
        handle: { breadcrumb: "Supplies" },
        children: [
          {
            path: "price-books",
            handle: { breadcrumb: "Price books" },
            children: [
              {
                index: true,
                async lazy() {
                  const { RedoSuppliesPriceBooksPage } =
                    await import("../pages/redo-supplies-price-books/redo-supplies-price-books-page");

                  return { Component: RedoSuppliesPriceBooksPage };
                },
              },
              {
                path: ":priceBookId",
                async lazy() {
                  const { PriceBookDetailPage } =
                    await import("../pages/redo-supplies-price-books/price-book-detail-page");

                  return { Component: PriceBookDetailPage };
                },
              },
            ],
          },
          {
            path: "inventory-configs",
            handle: { breadcrumb: "Inventory configurations" },
            async lazy() {
              const { SuppliesInventoryConfigsPage } =
                await import("../pages/supplies-inventory-configs/supplies-inventory-configs-page");

              return { Component: SuppliesInventoryConfigsPage };
            },
          },
          {
            path: "subscriptions",
            handle: { breadcrumb: "Subscriptions" },
            async lazy() {
              const { SuppliesSubscriptionsPage } =
                await import("../pages/supplies-subscriptions/supplies-subscriptions-page");

              return { Component: SuppliesSubscriptionsPage };
            },
          },
          {
            path: "trackable-products",
            handle: { breadcrumb: "Trackable products" },
            async lazy() {
              const { TrackableProductsPage } =
                await import("../pages/supplies-trackable-products/trackable-products-page");

              return { Component: TrackableProductsPage };
            },
          },
          {
            path: "storefront-customization",
            handle: { breadcrumb: "Storefront customization" },
            async lazy() {
              const { StorefrontCustomizationPage } =
                await import("../pages/supplies-storefront-customization/storefront-customization-page");

              return { Component: StorefrontCustomizationPage };
            },
          },
        ],
      },
    ],
  },
];
